import P1Content from "@/components/P1Content";
import NewsList from "./components/NewsList";
import styles from "./index.module.less";
import { useState } from "react";
import data from "./data";
import { isMobile } from "@/utils";
import MobileNews from "./mobile/mobile";

const PAGE_SIZE = 12;
const News = () => {
  const [page, setPage] = useState(1);
  return (
    <div className={styles.page}>
      <div className={styles.p1}>
        <P1Content
          title="近期焦点"
          subtitle="聚焦实践，引领创新"
          showBtn={false}
        />
      </div>
      <div className={styles.p2}>
        <NewsList list={data.newsList.slice(0, page * PAGE_SIZE)} />
        <div
          className={styles.more_btn}
          onClick={() => {
            if (page * PAGE_SIZE >= data.newsList.length) {
              return;
            }
            setPage((prev) => prev + 1);
          }}
        >
          MORE
        </div>
      </div>
    </div>
  );
};
export default isMobile() ? MobileNews : News;
